"use client";
import { useState } from "react";
import tipIcon from "@/assets/icons/tipIcon.svg";
import Image from "next/image";
import ScalePopup from "../Popups/ScalePopup";

export default function ScaleTrigger({ category }: { category: string }) {
  const [isPopupOpen, setPopupOpen] = useState(false);

  return (
    <>
      {/* Clickable div to open popup */}
      <div className="cursor-pointer mt-1 " onClick={() => setPopupOpen(true)}>
        <Image
          src={tipIcon}
          alt="icon"
          loading="eager"
          priority
        />
      </div>

      {/* Show popup when state is true */}
      {isPopupOpen && <ScalePopup category={category} close={() => setPopupOpen(false)} />}
    </>
  );
}